/**
 * Sanitizes a filename by removing the extension, truncating the name, and appending the extension back in lowercase.
 * This is useful for both web and mobile file uploads to ensure consistent naming.
 */
export const sanitizeFilename = (filename: string): string => {
  // Remove the extension first
  const lastDot = filename.lastIndexOf('.');
  if (lastDot === -1) return filename.slice(0, 200);

  const extension = filename.slice(lastDot).toLowerCase();
  let name = filename.slice(0, lastDot);

  // Ensure the name isn't empty
  if (!name) name = 'file';

  // Limit length (keeping space for extension)
  name = name.slice(0, 200);

  return `${name}${extension}`;
};
